import { SxProps, Theme } from "@mui/material";

import { OverlayContentPosition } from "./types";

export const getSxPosition = (
  position: OverlayContentPosition,
  padding: string | number = "8px"
): SxProps<Theme> => {
  const SX_POSITIONS: Record<OverlayContentPosition, SxProps<Theme>> = {
    bottomCenter: {
      bottom: padding,
      left: "50%",
      transform: "translate(-50%, 0)"
    },
    bottomLeft: {
      bottom: padding,
      left: padding
    },
    bottomRight: {
      bottom: padding,
      right: padding
    },
    topCenter: {
      top: padding,
      left: "50%",
      transform: "translate(-50%, 0)"
    },
    topLeft: {
      top: padding,
      left: padding
    },
    topRight: {
      top: padding,
      right: padding
    },
    centerCenter: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)"
    },
    centerLeft: {
      top: "50%",
      left: padding,
      transform: "translate(0,-50%)"
    },
    centerRight: {
      top: "50%",
      right: padding,
      transform: "translate(0,-50%)"
    }
  };

  return SX_POSITIONS[position];
};
